import React from 'react'
import { TableCell, TableRow } from 'transfix-ui/components/Table'
import { Skeleton, SkeletonProps } from 'transfix-ui/core'
import { makeStyles } from 'transfix-ui/core/styles'

const useTextSkeletonStyles = makeStyles({
  root: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
  },
})

const TextSkeleton = (props: Omit<SkeletonProps, 'variant' | 'height'>) => {
  const classes = useTextSkeletonStyles()
  return <Skeleton variant='text' className={classes.root} height={19.59} {...props} />
}

export const ShipperTableRowSkeleton = () => (
  <TableRow>
    <TableCell>
      <TextSkeleton width={86.29} />
    </TableCell>
    <TableCell>
      <Skeleton width={248.73} />
    </TableCell>
    <TableCell>
      <Skeleton width={67} />
    </TableCell>
  </TableRow>
)

export default ShipperTableRowSkeleton
